import { IChangeTransferPin, IHookForm } from "../../interfaces-and-types";
import { SubmitButton } from "../../hook-form";
import {
  ModalContainer,
  PinCodeInputModal,
  PinPromptWithDisplay,
  SectionHeader,
} from "../../components";

interface IChangeTransferPinViewProps extends IHookForm<IChangeTransferPin> {
  isModalOpen: boolean;
  closeModal: () => void;

  formValues: IChangeTransferPin;

  isOpenCurrentPinInput: boolean;
  onOpenCurrentPinInput: () => void;
  onCloseCurrentPinInput: () => void;
  combinedCurrentPinInputErrors: string | null;
  onCurrentPinSubmit: (confirmPin: string) => boolean;
  onCurrentPinCorrect: (/*pin: string*/) => boolean;

  isOpenNewPinInput: boolean;
  onOpenNewPinInput: () => void;
  onCloseNewPinInput: () => void;
  combinedNewPinInputErrors: string | null;
  onNewPinSubmit: (pin: string) => boolean;
  onNewPinCorrect: (/*pin: string*/) => boolean;

  isOpenConfirmPinInput: boolean;
  onOpenConfirmPinInput: () => void;
  onCloseConfirmPinInput: () => void;
  combinedConfirmPinInputErrors: string | null;
  onConfirmPinSubmit: (confirmPin: string) => boolean;
  onConfirmPinCorrect: (/*pin: string*/) => boolean;
}

export const View = ({
  isModalOpen,
  closeModal,

  formValues,

  isOpenCurrentPinInput,
  onOpenCurrentPinInput,
  onCloseCurrentPinInput,
  combinedCurrentPinInputErrors,
  onCurrentPinSubmit,
  onCurrentPinCorrect,

  isOpenNewPinInput,
  onOpenNewPinInput,
  onCloseNewPinInput,
  combinedNewPinInputErrors,
  onNewPinSubmit,
  onNewPinCorrect,

  isOpenConfirmPinInput,
  onOpenConfirmPinInput,
  onCloseConfirmPinInput,
  combinedConfirmPinInputErrors,
  onConfirmPinSubmit,
  onConfirmPinCorrect,

  errors,
  handleSubmit,
  register,
  control,
}: IChangeTransferPinViewProps) => {
  return (
    <>
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Change Transfer PIN"
            subtitle="Change your transfer PIN."
          />
        }
      >
        <form onSubmit={handleSubmit}>
          <div className="flex-container col justify-content--center align-items--center">
            <div style={{ minWidth: "50%", maxWidth: 800 }}>
              <div className="flex-container col mt-5">
                <span>Current PIN</span>

                <div onClick={onOpenCurrentPinInput}>
                  <PinPromptWithDisplay
                    pin={formValues.current_pin}
                    placeHolder={"Enter Current PIN"}
                  />

                  <span className="switchapp-small text-danger font-ctm--semibold fontSize-12">
                    {combinedCurrentPinInputErrors}
                  </span>
                </div>
              </div>

              <div className="flex-container col mt-5">
                <div className="flex-container mb-3">
                  <div className="flex-box">New PIN</div>
                </div>

                <div onClick={onOpenNewPinInput}>
                  <PinPromptWithDisplay
                    pin={formValues.new_pin}
                    placeHolder={"Enter New PIN"}
                  />

                  <span className="switchapp-small text-danger font-ctm--semibold fontSize-12">
                    {combinedNewPinInputErrors}
                  </span>
                </div>
              </div>

              <div className="flex-container col mt-5">
                <span>Confirm New PIN</span>

                <div onClick={onOpenConfirmPinInput}>
                  <PinPromptWithDisplay
                    pin={formValues.confirm_pin}
                    placeHolder={"Confirm New PIN"}
                  />

                  <span className="switchapp-small text-danger font-ctm--semibold fontSize-12">
                    {combinedConfirmPinInputErrors}
                  </span>
                </div>
              </div>

              <div className="flex-container mt-5">
                <SubmitButton className=" mt-5 align-self--stretch">
                  Save PIN
                </SubmitButton>
              </div>
            </div>
          </div>
        </form>
      </ModalContainer>

      <PinCodeInputModal
        title="Current Transfer PIN"
        subtitle="Enter current PIN"
        // buttonText="Submit PIN"
        errorMessage={combinedCurrentPinInputErrors} // get from useApiErrors()
        showPinValues={false}
        isModalOpen={isOpenCurrentPinInput}
        closeModal={onCloseCurrentPinInput}
        onChange={onCurrentPinSubmit}
        handlePinSubmit={onCurrentPinCorrect}
        pin={formValues.current_pin}
        pinCodeLength={4}
        // onPinCorrect={onNewPinCorrect}
      />

      <PinCodeInputModal
        title="New Transfer PIN"
        subtitle="Enter your new 4-digit code for transfers"
        // buttonText="Submit PIN"
        errorMessage={combinedNewPinInputErrors} // get from useApiErrors()
        showPinValues={false}
        isModalOpen={isOpenNewPinInput}
        pin={formValues.new_pin}
        pinCodeLength={4}
        closeModal={onCloseNewPinInput}
        onChange={onNewPinSubmit}
        handlePinSubmit={onNewPinCorrect}
      />

      <PinCodeInputModal
        title="Confirm Transfer PIN"
        subtitle="Enter same digits again to confirm..."
        // buttonText="Submit PIN"
        errorMessage={combinedConfirmPinInputErrors} // get from useApiErrors()
        showPinValues={false}
        isModalOpen={isOpenConfirmPinInput}
        pin={formValues.confirm_pin}
        pinCodeLength={4}
        closeModal={onCloseConfirmPinInput}
        onChange={onConfirmPinSubmit}
        handlePinSubmit={onConfirmPinCorrect}
      />
    </>
  );
};
